import { useId, useState } from 'react';
import { usePeriod } from '../context/PeriodContext';
import { formatPeriod } from '../format';
import { MOVIL, useMediaQuery } from '../hooks/useMediaQuery';

/** Selector de periodo global: presets rapidos + rango a medida. */
export function PeriodPicker(): JSX.Element {
  const { period, setPeriod, presets } = usePeriod();
  const presetId = useId();
  const startId = useId();
  const endId = useId();

  const activeFromPeriod =
    presets.find((p) => p.period.start === period.start && p.period.end === period.end)?.id ??
    'custom';

  // Las fechas exactas son un ajuste secundario. Tener siempre tres campos en
  // la cabecera convertia el periodo en un formulario enorme y dejaba el rango
  // repetido dos veces. Se despliegan solo cuando alguien quiere afinarlas.
  const esMovil = useMediaQuery(MOVIL);
  const [fechasAbiertas, setFechasAbiertas] = useState(false);
  const [eligiendoPersonalizado, setEligiendoPersonalizado] = useState(false);
  const active = eligiendoPersonalizado ? 'custom' : activeFromPeriod;
  const mostrarFechas = fechasAbiertas || active === 'custom';

  return (
    <div className="period">
      <div className="period__group">
        <label className="period__label" htmlFor={presetId}>
          Periodo
        </label>
        <select
          id={presetId}
          className="input input--compact"
          value={active}
          onChange={(event) => {
            const preset = presets.find((p) => p.id === event.target.value);
            if (preset) {
              setPeriod(preset.period);
              setFechasAbiertas(false);
              setEligiendoPersonalizado(false);
            } else {
              setFechasAbiertas(true);
              setEligiendoPersonalizado(true);
            }
          }}
        >
          {presets.map((preset) => (
            <option key={preset.id} value={preset.id}>
              {preset.label}
            </option>
          ))}
          <option value="custom">Rango personalizado</option>
        </select>
      </div>

      <p className="period__summary" aria-live="polite">
        {formatPeriod(period.start, period.end)}
      </p>

      {active !== 'custom' && (
        <button
          type="button"
          className="period__toggle"
          aria-expanded={fechasAbiertas}
          onClick={() => setFechasAbiertas((v) => !v)}
        >
          {fechasAbiertas ? 'Cerrar' : esMovil ? 'Fechas' : 'Cambiar fechas'}
        </button>
      )}

      {mostrarFechas && (
      <div className="period__custom">
      <div className="period__group">
        <label className="period__label" htmlFor={startId}>
          Desde
        </label>
        <input
          id={startId}
          type="date"
          className="input input--compact"
          value={period.start}
          max={period.end}
          onChange={(event) =>
            setPeriod({ ...period, start: event.target.value || period.start })
          }
        />
      </div>

      <div className="period__group">
        <label className="period__label" htmlFor={endId}>
          Hasta
        </label>
        <input
          id={endId}
          type="date"
          className="input input--compact"
          value={period.end}
          min={period.start}
          onChange={(event) => setPeriod({ ...period, end: event.target.value || period.end })}
        />
      </div>
      </div>
      )}
    </div>
  );
}
